/* eslint-disable max-len */
import * as React from 'react'
const SelectedSvg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle cx={24} cy={24} r={19.5} fill="#000" stroke="#000" />
      <path
        fill="#FFE608"
        d="m33.671 20.514-9.879 9.981a1.502 1.502 0 0 1-2.134 0l-5.667-5.714a1.616 1.616 0 0 1-.151-2.267 1.584 1.584 0 0 1 2.248-.152l4.628 4.667 8.707-8.781a1.502 1.502 0 0 1 2.135 0l.132.133c.57.598.562 1.546-.019 2.133Z"
      />
    </g>
  </svg>
)
export default SelectedSvg
